var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "button",
      {
        staticClass: "icon-button",
        attrs: { title: "Previous day", disabled: _vm.prevDisabled },
        on: {
          click: function($event) {
            return _vm.$emit("date-change", -1, _vm.startOrEnd)
          }
        }
      },
      [
        _c("i", {
          staticClass: "fas fa-arrow-left",
          attrs: { title: "Previous day" }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "icon-button",
        attrs: { title: "Next day", disabled: _vm.nextDisabled },
        on: {
          click: function($event) {
            return _vm.$emit("date-change", +1, _vm.startOrEnd)
          }
        }
      },
      [
        _c("i", {
          staticClass: "fas fa-arrow-right",
          attrs: { title: "Next day" }
        })
      ]
    ),
    _vm._v(" "),
    _vm.showReset
      ? _c(
          "button",
          {
            staticClass: "icon-button",
            attrs: { title: "Reset " + _vm.startOrEnd + " day" },
            on: {
              click: function($event) {
                return _vm.$emit("date-change", 0, _vm.startOrEnd)
              }
            }
          },
          [
            _c("i", {
              staticClass: "fas fa-redo",
              attrs: { title: "Reset " + _vm.startOrEnd + " day" }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }